<script>
import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";
import TextEllipsis from "@/components/commonComponents/TextEllipsis.vue";

export default {
    name: "VDataTableWordClouds",
    components: {
        TextEllipsis,
        VDataTableCustom,
    },
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id',
                    width: 100,
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    tooltip: 'Идентификатор в системе учета ESS',
                },
                {
                    text: 'Период',
                    align: 'left',
                    sortable: true,
                    value: 'date_start',
                    width: 100,
                },
                {
                    text: 'Слова',
                    align: 'start',
                    sortable: true,
                    value: 'preview',
                    cellClass: 'text'
                },
                {
                    text: 'Создано',
                    align: 'center',
                    sortable: true,
                    value: 'created_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
                {
                    text: 'Обновлено',
                    align: 'center',
                    sortable: true,
                    value: 'updated_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
            ],
        };
    },
}
</script>

<template>
    <v-data-table-custom
        v-bind="$attrs"
        v-on="$listeners"
        :headers="headers"
        item-key="id"
        permissions-by-module="wordclouds"
    >
        <template v-slot:item.date_start="{item}">
<!--            <template v-if="item.date_start !== item.date_end">
                {{ item.date_start | moment('DD.MM.Y') }}
                -
                {{ item.date_end | moment('DD.MM.Y') }}
            </template>-->
            <template v-if="item.date_start !== item.date_end">
                Форум
            </template>
            <template v-else>
                {{ item.date_start | moment('DD.MM.Y') }}
            </template>
        </template>
        <template v-slot:item.preview="{value}">
            <text-ellipsis :multiline="2">
                {{ value }}
            </text-ellipsis>
        </template>
    </v-data-table-custom>
</template>

<style scoped lang="scss">
.v-data-table ::v-deep tr td.text {
    padding-top: 4px;
    padding-bottom: 4px;
}
</style>
